/**
 * Zentrale App-Versionsquelle.
 *
 * Die Version wird ausschließlich aus ``frontend/package.json`` gelesen —
 * für einen Release-Bump muss also nur dort ``version`` angehoben werden.
 * CRA/Webpack löst ``import from "../../package.json"`` zur Build-Zeit
 * statisch auf, sodass zur Laufzeit keine Netzwerk-/FS-Abhängigkeit
 * besteht.
 */
import pkg from "../../package.json";

export const APP_VERSION = pkg.version;

/** Kanonischer Browser-Titel — bei Bedarf zentral hier anpassen. */
export const APP_TITLE = `Inventory (V${APP_VERSION})`;
